import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'gtw-form-view-tab',
    templateUrl: './form-view-tab.component.html',
    styleUrls: ['./form-view-tab.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FormViewTabComponent {}
